import * as types from './serviceActionType'
const initialState = {
  serviceTripCodeData: [],
  serviceCategoryData: [],
  serviceManageTableData: [],
  serviceDepotList: [],
  serviceLayoutList: [],
  serviceRouteDetails: {},
  serviceStopList: [],
  serviceDroppingPoint: [],
  serviceBoardingPoint: [],
  serviceCityList: [],
  seviceCancelData: [],
  serviceDepotListV2: [],
}
const serviceMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SERVICE_TRIPCODE_DATA:
      return { ...state, serviceTripCodeData: action.payload };
    case types.SERVICE_CATEGORY_DATA:
      return { ...state, serviceCategoryData: action.payload };
    case types.SERVICE_MANAGE_TABLE_DATA:
      return { ...state, serviceManageTableData: action.payload };
    case types.SERVICE_DEPOT_LIST:
      return { ...state, serviceDepotList: action.payload }
    case types.SERVICE_CHART_LIST:
      return { ...state, serviceLayoutList: action.payload }
    case types.SERVICE_ROUTE_DETAILS:
      return { ...state, serviceRouteDetails: action.payload }
    case types.SERVICE_STIP_LIST:
      return { ...state, serviceStopList: action.payload }
    case types.BOARDING_POINT:
      return { ...state, serviceBoardingPoint: action.payload }
    case types.DROPPING_POINT:
      return { ...state, serviceDroppingPoint: action.payload }
    case types.SERVICE_CITY_LIST:
      return { ...state, serviceCityList: action.payload }
    case types.SERVICE_CANCEL_DATA:
      return { ...state, seviceCancelData: action.payload }
    case types.SERVICE_DEPOT_LISTV2:
      return { ...state, serviceDepotListV2: action.payload }
    default:
      return state;
  }
}

export default serviceMasterReducer
